module.exports = __webpack_public_path__ + "img/drops-bg3.d574e4ff.jpg";